import { createRouter, createWebHistory } from 'vue-router'

/** CMS pages are server-rendered HTML inside #app; there is no <router-view>. This route only satisfies Vue Router’s initial URL match so the console stays clean on non-SPA paths. */
const CmsPageShell = { name: 'CmsPageShell', render: () => null }

const routes = [
    {
        path: '/buy-vignette/:duration?',
        name: 'buy-vignette',
        // Lazy: must not sync-import BuyVignette or its step CSS lands in every page's JS.
        component: () => import('./components/BuyVignette/BuyVignette.vue'),
    },
    {
        path: '/payment-processing',
        name: 'payment-processing',
        component: () => import('./components/PaymentProcessing.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'cms-page',
        component: CmsPageShell,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
